import { useEffect, useRef, useState } from "react";

export interface DropdownOption {
  value: string;
  label: string;
}

interface DropdownProps {
  value: string;
  options: DropdownOption[];
  onChange: (value: string) => void;
  icon?: string;
  className?: string;
}

export default function Dropdown({
  value,
  options,
  onChange,
  icon = "ri-sort-desc",
  className = "",
}: DropdownProps) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  const current = options.find((option) => option.value === value);

  useEffect(() => {
    const handler = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  return (
    <div ref={ref} className={`relative ${className}`}>
      <button
        type="button"
        onClick={() => setOpen((prev) => !prev)}
        className="inline-flex items-center gap-2 h-9 px-3 rounded-md bg-background-50 border border-background-300 text-sm text-foreground-800 hover:border-primary-400 cursor-pointer whitespace-nowrap transition-colors"
      >
        <i className={`${icon} text-base text-foreground-500`}></i>
        {current ? current.label : "请选择"}
        <i
          className={`ri-arrow-down-s-line text-base text-foreground-400 transition-transform ${
            open ? "rotate-180" : ""
          }`}
        ></i>
      </button>
      {open ? (
        <div className="absolute right-0 z-30 mt-1.5 w-40 py-1.5 rounded-md bg-background-50 border border-background-200 shadow-lg animate-scale-in">
          {options.map((option) => (
            <button
              key={option.value}
              type="button"
              onClick={() => {
                onChange(option.value);
                setOpen(false);
              }}
              className={`w-full flex items-center justify-between px-3 py-2 text-sm cursor-pointer hover:bg-background-100 transition-colors ${
                option.value === value
                  ? "text-primary-600 font-medium"
                  : "text-foreground-700"
              }`}
            >
              {option.label}
              {option.value === value ? (
                <i className="ri-check-line text-base"></i>
              ) : null}
            </button>
          ))}
        </div>
      ) : null}
    </div>
  );
}